import o from "../isDate/index.js";
import t from "../toDate/index.js";
import m from "../_lib/requiredArgs/index.js";
function u(r) {
  if (m(1, arguments), !o(r) && typeof r != "number")
    return !1;
  var e = t(r);
  return !isNaN(Number(e));
}
export {
  u as default
};
//# sourceMappingURL=index.js.map
